import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IToken } from 'src/app/modules/login/services/DTO/response/LoginResponse.DTO';
import { LoginService } from 'src/app/modules/login/services/login.service';
import { LightboxesService } from '../components/lightboxes/lightboxes.service';
import { CorretorService } from '../services/corretor.service';
import { ICorretor } from '../types/ICorretor';
import { CorretorState } from '../states/corretor.state';
import { ProdutoFacade } from './produto.facade';

@Injectable({ providedIn: 'root' })
export class CorretorFacade {
  constructor(
    private corretorService: CorretorService,
    private corretorState: CorretorState,
    private produtoFacade: ProdutoFacade,
    private router: Router,
    private loginService: LoginService,
    private lightboxesService: LightboxesService,
  ) { }

  login(cpf: string, senha: string, shouldSaveLoginInLocalStorage: boolean) {
    this.corretorState.setRequestingLogin(true);

    this.loginService.createTokenApi({ Cpf: cpf, Senha: senha }).subscribe(
      response => this.handleSuccessfulLogin(response, cpf, shouldSaveLoginInLocalStorage),
      error => this.handleFailureLogin(error),
      () => this.corretorState.setRequestingLogin(false),
    );
  }

  requestCorretor() {
    this.corretorState.setRequestingCorretor(true);

    this.corretorService.getCorretorLogado().subscribe(
      response => this.handleSuccessfulGetCorretor(response),
      error => this.handleFailureGetCorretor(error),
      () => this.corretorState.setRequestingCorretor(false),
    );
  }

  requestCorretorIfUnset() {
    if(this.corretorState.isEmpty())
      this.requestCorretor();
  }

  logout() {
    this.corretorState.reset();
    this.produtoFacade.reset();

    this.router.navigate(['/login']);
    sessionStorage.clear();
  }

  private handleSuccessfulLogin(response: IToken, cpf: string, shouldSaveLoginInLocalStorage: boolean) {
    if(response !== null) {
      sessionStorage.setItem('token', response.token);

      if(shouldSaveLoginInLocalStorage)
        localStorage.setItem('login', cpf);
      else
        localStorage.removeItem('login');

      this.router.navigate(['/home']);
    }
    else
      this.lightboxesService.open({
        title: 'Atenção',
        text: `Dados inválidos. <br> Caso não saiba sua senha ou seja seu primeiro acesso, <br> solicite um lembrete de senha na tela de login.`
      }, 7000);
  }

  private handleFailureLogin(error: any) {
    this.lightboxesService.open({
      title: 'Atenção',
      text: 'Não foi possível efetuar o login. Tente novamente mais tarde.'
    }, 5_000);

    this.corretorState.setRequestingLogin(false);
  }

  private handleSuccessfulGetCorretor(response: ICorretor) {
    this.corretorState.setCorretor(response);
  }

  private handleFailureGetCorretor(error: any) {
    this.lightboxesService.open({
      title: 'Atenção',
      text: 'Não foi possível obter seus dados no momento. Tente novamente mais tarde.',
    });

    this.logout();
  }

  getCorretor() {
    return this.corretorState.getCorretor();
  }

  getCorretorValue() {
    return this.corretorState.getCorretorValue();
  }

  isRequestingCorretor() {
    return this.corretorState.isRequestingCorretor();
  }

  isRequestingLogin() {
    return this.corretorState.isRequestingLogin();
  }
}
